'use client'

import { Provider } from 'react-redux'
import store from '../reduxToolkit/store'
// import InitializeThemes from "./InitializeThemes"

export default function GlobalProviders({ children }) {
  return <Provider store={store}>{children}</Provider>
}
